import { Helmet } from "react-helmet-async";
import Footer from "../General/Footer";
import NavBar from "../General/Nav";
import Newsletter from "./Components/NewsLetter";
import Actualite from "./Components/Actualite";
import Temoignage from "./Components/Temoignage";
import Client from "./Components/Client";
import HeroBannerHome from "./Components/HeroBanner";
import SavoirFaire from "./Components/SavoirFaire";
import TravaillerEnsemble from "./Components/TravaillerEnsemble";
import HomeNumber from "./Components/Number";
import { useTraduction } from "../Contexte/TraductionContext";

function HomePage() {
    const { contentAccueil, contentUrl } = useTraduction()

    return (
        <>
            <Helmet>
                <title>{contentAccueil.Title}</title>
                <meta name="description" content={contentAccueil.MetaDescription} />
                <link rel="canonical" href={contentUrl.domainName + "/"}></link>
            </Helmet>
            <NavBar />
            <HeroBannerHome />
            <HomeNumber />
            <SavoirFaire />
            <TravaillerEnsemble />
            <Client />
            <Temoignage />
            <Actualite />
            <Newsletter />
            <Footer />
        </>
    );
}

export default HomePage;
